<template lang="html">
  <div class="bg-body-light">
    <div class="content content-full">
      <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center">
        <h1 class="flex-sm-fill font-size-h2 font-w400 mt-2 mb-0 mb-sm-2">{{ header }}</h1>
        <nav aria-label="breadcrumb" class="flex-sm-00-auto ml-sm-3">
          <ol class="breadcrumb">
            <router-link v-for="(link, index) in urls" class="breadcrumb-item" :key="index" tag="a" :to="link.to">
              {{ link.label }}
            </router-link>
          </ol>
        </nav>
      </div>
    </div>
    <!-- <pre>{{ urls }}</pre> -->
  </div>
</template>

<script>
  export default {
    props: {
      header: {
        type: String,
        default: 'Header'
      },
      breadcrumb: {
        type: Array,
        default: () => [
          {
            label: 'Home',
            to: { path: '/' }
          },
          {
            label: 'test',
            to: { path: '/test' }
          }
        ]
      }
    },
    data() {
      return {
        urls: []
      }
    },
    mounted() {
      this.setup()
    },
    methods: {
      setup() {
        if (this.$route.matched[0].meta && this.$route.matched[0].meta.name) {
          this.header = this.$route.matched[0].meta.name
        }
        this.urls = this.$route.matched.reduce((urls, route) => {
          const url = {
            label: route.meta.title || 'Link',
            to: { path: route.path }
          }
          urls.push(url)
          return urls
        }, [])
      }
    }
  }
</script>

<style lang="css" scoped>
  .breadcrumb-item {
    color: #495057;
  }

  .breadcrumb-item:hover {
    color: #000000;
  }
</style>
